import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Select,
  Table,
  Card,
  Space,
  Tag,
  Drawer,
  message,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { VedorApiAction } from "../../_actions/vendorApi.service";
import axios from "axios";

const { Option } = Select;

const ApiManager = () => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [fields, setFields] = useState([
    {
      field_name: "",
      field_type: "",
      field_description: "",
      is_required: false,
      param_type: "body",
    },
  ]);
  const [apiList, setApiList] = useState([]);
  const [testDrawer, setTestDrawer] = useState(false);
  const [selectedApi, setSelectedApi] = useState(null);
  const [testValues, setTestValues] = useState({});
  const getApiConfigs = () => {
    VedorApiAction.getApiConfigs().then((res) => {
      setApiList(res.data);
    });
  };

  useEffect(() => {
    getApiConfigs();
  }, []);

  // ✅ Open Drawer
  const showDrawer = () => {
    setOpen(true);
  };

  // ✅ Close Drawer
  const onClose = () => {
    setOpen(false);
  };

  // ✅ Add field
  const addField = () => {
    setFields([
      ...fields,
      {
        field_name: "",
        field_type: "",
        field_description: "",
        is_required: false,
        param_type: "body",
      },
    ]);
  };

  // ✅ Remove field
  const removeField = (index) => {
    const updated = [...fields];
    updated.splice(index, 1);
    setFields(updated);
  };

  // ✅ Handle change
  const handleFieldChange = (index, key, value) => {
    const updated = [...fields];
    updated[index][key] = value;
    setFields(updated);
  };

  // ✅ Submit
  const onFinish = async (values) => {
    const payload = {
      ...values,
      fields,
    };

    await VedorApiAction.addApi(payload);
    message.success("Added successfully");

    form.resetFields();
    setFields([
      {
        field_name: "",
        field_type: "",
        field_description: "",
        is_required: false,
        param_type: "body",
      },
    ]);

    setOpen(false);
  };

  const openTestDrawer = (record) => {
    setSelectedApi(record);
    setTestDrawer(true);

    // reset values
    const initial = {};
    (record.fields || []).forEach((f) => {
      initial[f.field_name] = "";
    });
    setTestValues(initial);
  };
  const handleTestChange = (key, value) => {
    setTestValues({
      ...testValues,
      [key]: value,
    });
  };

  const handleTestApi = async () => {
    try {
      const queryParams = {};
      const bodyParams = {};

      selectedApi.fields.forEach((f) => {
        if (f.param_type === "query") {
          queryParams[f.field_name] = testValues[f.field_name];
        } else {
          bodyParams[f.field_name] = testValues[f.field_name];
        }
      });

      const response = await axios({
        method: selectedApi.method,
        url: `${selectedApi.endpoint}`,
        params: queryParams,
        data: bodyParams,
      });

      message.success("API Success ✅");

      console.log("Response:", response.data);
    } catch (error) {
      message.error("API Failed ❌");
      console.error(error);
    }
  };
  // ✅ Table columns
  const columns = [
    {
      title: "Sr.No",
      render: (_, __, index) => index + 1,
    },
    {
      title: "API Name",
      dataIndex: "api_name",
    },
    {
      title: "Endpoint",
      dataIndex: "endpoint",
    },
    {
      title: "Method",
      dataIndex: "method",
      render: (text) => <Tag color="blue">{text}</Tag>,
    },
    {
      title: "Action",
      render: (_, record) => (
        <Button type="link" onClick={() => openTestDrawer(record)}>
          Test API
        </Button>
      ),
    },
  ];

  // ✅ Expand row
  const expandedRowRender = (record) => {
    const fieldColumns = [
      { title: "Field Name", dataIndex: "field_name" },
      { title: "Type", dataIndex: "field_type" },
      { title: "Description", dataIndex: "field_description" },
      {
        title: "Required",
        dataIndex: "is_required",
        render: (val) => (val ? "Yes" : "No"),
      },
      {
        title: "Param Type",
        dataIndex: "param_type",
        render: (val) => (
          <Tag color={val === "query" ? "green" : "purple"}>{val}</Tag>
        ),
      },
    ];

    return (
      <Table
        columns={fieldColumns}
        dataSource={record.fields || []}
        pagination={false}
        rowKey="id"
      />
    );
  };

  return (
    <div style={{ padding: 20 }}>
      {/* ✅ HEADER */}
      <Card
        title="API List"
        extra={
          <Button type="primary" icon={<PlusOutlined />} onClick={showDrawer}>
            Add API
          </Button>
        }
      >
        <Table
          dataSource={apiList}
          columns={columns}
          rowKey="id"
          expandable={{ expandedRowRender }}
        />
      </Card>

      {/* ✅ DRAWER FORM */}
      <Drawer title="Add API" width={1000} onClose={onClose} open={open}>
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item
            name="api_name"
            label="API Name"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="endpoint"
            label="Endpoint"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>

          <Form.Item name="method" label="Method" rules={[{ required: true }]}>
            <Select>
              <Option value="GET">GET</Option>
              <Option value="POST">POST</Option>
              <Option value="PUT">PUT</Option>
              <Option value="DELETE">DELETE</Option>
            </Select>
          </Form.Item>

          <Form.Item name="description" label="Description">
            <Input />
          </Form.Item>

          <h3>Fields</h3>

          {fields.map((field, index) => (
            <Space key={index} style={{ display: "flex", marginBottom: 8 }}>
              <Input
                placeholder="Field Name"
                value={field.field_name}
                onChange={(e) =>
                  handleFieldChange(index, "field_name", e.target.value)
                }
              />

              <Input
                placeholder="Description"
                value={field.field_description}
                onChange={(e) =>
                  handleFieldChange(index, "field_description", e.target.value)
                }
              />

              <Select
                placeholder="Type"
                value={field.field_type}
                style={{ width: 120 }}
                onChange={(val) => handleFieldChange(index, "field_type", val)}
              >
                <Option value="string">String</Option>
                <Option value="number">Number</Option>
                <Option value="date">Date</Option>
              </Select>

              <Select
                value={field.is_required}
                style={{ width: 100 }}
                onChange={(val) => handleFieldChange(index, "is_required", val)}
              >
                <Option value={true}>Req</Option>
                <Option value={false}>Opt</Option>
              </Select>

              <Select
                value={field.param_type}
                style={{ width: 100 }}
                onChange={(val) => handleFieldChange(index, "param_type", val)}
              >
                <Option value="body">Body</Option>
                <Option value="query">Query</Option>
              </Select>

              <Button danger onClick={() => removeField(index)}>
                X
              </Button>
            </Space>
          ))}

          <Button type="dashed" onClick={addField}>
            + Add Field
          </Button>

          <br />
          <br />

          <Button type="primary" htmlType="submit">
            Save API
          </Button>
        </Form>
      </Drawer>
      <Drawer
        title="Test API"
        width={800}
        open={testDrawer}
        onClose={() => setTestDrawer(false)}
      >
        {selectedApi && (
          <>
            <p>
              <b>Endpoint:</b> {selectedApi.endpoint}
            </p>
            <p>
              <b>Method:</b> {selectedApi.method}
            </p>

            <h3>Params</h3>

            {selectedApi.fields?.map((field, index) => (
              <div key={index} style={{ marginBottom: 10 }}>
                <Input
                  placeholder={`${field.field_name} (${field.param_type})`}
                  value={testValues[field.field_name]}
                  onChange={(e) =>
                    handleTestChange(field.field_name, e.target.value)
                  }
                />
              </div>
            ))}

            <Button type="primary" onClick={handleTestApi}>
              Test API
            </Button>
          </>
        )}
      </Drawer>
    </div>
  );
};

export default ApiManager;
